function changedKeys( modelA, modelB, opts = { } ) {

  if ( Array.isArray( opts.keys ) ) {
    return opts.keys.filter( ( k ) => {
      return modelA[k] !== modelB[k]
    } )
  }

  const ignore = opts.ignore
  const changes = Object.keys( modelA ).filter( ( k ) => {
    if ( ignore && ignore.includes( k ) ) {
      return false
    }
    return modelA[k] !== modelB[k]
  } )

  // Grab any that may have been removed from modelB
  Object.keys( modelB ).forEach( ( k ) => {
    if ( ignore && ignore.includes( k ) ) {
      return
    }
    if ( modelA[k] === undefined && !changes.includes( k ) ) {
      changes.push( k )
    }
  } )

  return changes
}

function changeObject( newModel, oldModel, opts = { } ) {
  const undefinedIsNull = opts.undefinedIsNull || false
  const removeUndefined = opts.removeUndefined || false
  const changes = changedKeys( newModel, oldModel, opts )
  const rtn = { }
  changes.forEach( ( key ) => {
    const val = newModel[key]
    if ( !removeUndefined || val !== undefined ) {
      rtn[key] = val === undefined && undefinedIsNull ? null : val
    }
  } )
  return rtn
}

function changePatchOps( newModel, oldModel, opts = { } ) {
  const changes = changedKeys( newModel, oldModel, opts )
  const rtn = [ ]
  changes.forEach( ( key ) => {
    const val = newModel[key]
    if ( val === undefined ) {
      rtn.push( { path : key, op : 'remove' } )
    } else {
      rtn.push( { path : key, value : val, op : 'replace' } )
    }
  } )
  return rtn
}

export {
  changedKeys,
  changeObject,
  changePatchOps
}
